import { render, staticRenderFns } from "./balance-report.vue?vue&type=template&id=b06e00e4&scoped=true"
import script from "./balance-report.vue?vue&type=script&lang=js"
export * from "./balance-report.vue?vue&type=script&lang=js"
import style0 from "./balance-report.vue?vue&type=style&index=0&id=b06e00e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06e00e4",
  null
  
)

export default component.exports